import { VehicleConditionQuestions } from "./types";

export const VEHICLE_CONDITION_TRANSLATION_KEYS = {
  haveAirbagsDeployed: "vehicle_condition.airbags",
  isVehicleDrivable: "vehicle_condition.steering",
  mileage: "global.mileage",
  windshieldShattered: "vehicle_condition.windshield_shattered",
  canOpenAndCloseAllDoors: "vehicle_condition.can_open_and_close_all_doors",
} as const;

export const VEHICLE_CONDITION_QUESTION_DESCRIPTION_TRANSLATION_KEYS = {
  haveAirbagsDeployed: null,
  isVehicleDrivable: "vehicle_condition.instructions",
  windshieldShattered: null,
  canOpenAndCloseAllDoors: null,
} as const;

export const HIGH_MILEAGE = 300_000;

export const LOW_MILEAGE = 100;

export enum QuestionKeys {
  AirbagsDeployed = "airbags-deployed",
  IsDrivable = "is-drivable",
  WindshieldShattered = "windshield-shattered",
  CanOpenAndCloseAllDoors = "can-open-close-all-doors",
}

export const QuestionsKeyMap: Record<keyof VehicleConditionQuestions, QuestionKeys> = {
  haveAirbagsDeployed: QuestionKeys.AirbagsDeployed,
  isVehicleDrivable: QuestionKeys.IsDrivable,
  windshieldShattered: QuestionKeys.WindshieldShattered,
  canOpenAndCloseAllDoors: QuestionKeys.CanOpenAndCloseAllDoors,
};
